const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || 'https://cappy-api-test-app.azurewebsites.net/'
const AUTH_API_ENDPOINT = process.env.REACT_APP_AUTH_API_ENDPOINT || 'https://cappy-auth-test-app.azurewebsites.net/'
const PORTAL_API_ENDPOINT = API_ENDPOINT + 'portal/'

const BLAZOR_APP_VERSION = process.env.REACT_APP_BLAZOR_APP_VERSION || '8.0.0'

const FORTNOX_INTEGRATION_API_ENDPOINT = 'https://fortnox-customer-integration-app.azurewebsites.net/'
const PLANDAY_INTEGRATION_API_ENDPOINT = 'https://planday-customer-integration-app.azurewebsites.net/'
const TENGELLA_INTEGRATION_API_ENDPOINT = 'https://tengella-customer-integration-app.azurewebsites.net/'

export const apiConfig = {
    baseUrlAuth: AUTH_API_ENDPOINT,
    baseUrl: PORTAL_API_ENDPOINT,
    routes: {
        auth: `${PORTAL_API_ENDPOINT}auth/`,
        password: `${PORTAL_API_ENDPOINT}password/`,
        sendPasswordLink: `${PORTAL_API_ENDPOINT}password/sendlink/`,
        customerUsers: `${PORTAL_API_ENDPOINT}customer/users/`,
        companyGroupUsers: `${PORTAL_API_ENDPOINT}companygroup/users/`,
        paySchedules: `${PORTAL_API_ENDPOINT}customer/paySchedules/`,
        employees: `${PORTAL_API_ENDPOINT}customer/employees/`,
        employeeActivation: `${PORTAL_API_ENDPOINT}customer/employeeActivation/`,
        employeeDeactivation: `${PORTAL_API_ENDPOINT}customer/employeeDeactivation/`,
        employeeDeactivationHistory: `${PORTAL_API_ENDPOINT}customer/employeeDeactivation/deactivated/`,
        shifts: `${PORTAL_API_ENDPOINT}customer/shifts/`,
        openShifts: `${PORTAL_API_ENDPOINT}customer/openshifts/`,
        payDeviations: `${PORTAL_API_ENDPOINT}customer/payDeviations/`,
        creditUsage: `${PORTAL_API_ENDPOINT}customer/creditUsage/`,
        customer: `${PORTAL_API_ENDPOINT}customer/`,
        employer: `${PORTAL_API_ENDPOINT}customer/employer/`,
        companyGroup: `${PORTAL_API_ENDPOINT}companygroup/`,
        integrationLog: `${PORTAL_API_ENDPOINT}customer/integrationlog/`,
        payroll: `${PORTAL_API_ENDPOINT}customer/payroll/`,
        employerInitiatedPayouts: `${PORTAL_API_ENDPOINT}customer/employerInitiatedPayouts/`,
        customerFiles: `${PORTAL_API_ENDPOINT}customer/files/`,
        companyGroupFiles: `${PORTAL_API_ENDPOINT}companygroup/files/`,
        payoutBasis: `${PORTAL_API_ENDPOINT}customer/payoutBasis/`,
        advancePayoutBasisFile: `${PORTAL_API_ENDPOINT}customer/files/advancepayoutbasis/`,
        deductionPayoutBasisFile: `${PORTAL_API_ENDPOINT}customer/files/deductionpayoutbasis/`,
        bankAccountImportFile: `${PORTAL_API_ENDPOINT}customer/files/bankaccount/`,
        employeeDeactivationImportFile: `${PORTAL_API_ENDPOINT}customer/files/employeedeactivation/`,
        companyGroupAdvancePayoutBasisFile: `${PORTAL_API_ENDPOINT}companygroup/files/advancepayoutbasis/`,
        companyGroupDeductionPayoutBasisFile: `${PORTAL_API_ENDPOINT}companygroup/files/deductionpayoutbasis/`,
        companyGroupBankAccountImportFile: `${PORTAL_API_ENDPOINT}companygroup/files/bankaccount/`,
        companyGroupEmployeeDeactivationImportFile: `${PORTAL_API_ENDPOINT}companygroup/files/employeedeactivation/`,
        companyGroupEmployeeDeactivation: `${PORTAL_API_ENDPOINT}companygroup/employeeDeactivation/`,
        companyGroupEmployeeDeactivationHistory: `${PORTAL_API_ENDPOINT}companygroup/employeeDeactivation/deactivated/`,
        paymentNotificationFiles: `${PORTAL_API_ENDPOINT}customer/files/paymentNotification/`,
        creditReportFiles: `${PORTAL_API_ENDPOINT}customer/files/creditreport/`,
        agiAdjustmentSieFiles: `${PORTAL_API_ENDPOINT}customer/files/agiAdjustment/sie/`,
        agiAdjustmentReportFile: `${PORTAL_API_ENDPOINT}customer/files/agiAdjustment/adjustmentReport/`,
        foraAdjustmentReportFile: `${PORTAL_API_ENDPOINT}customer/files/foraAdjustment/adjustmentReport/`,
        remainingDebtReportFile: `${PORTAL_API_ENDPOINT}customer/files/remainingDebtReport/`,
        employeeForeclosureReportFile: `${PORTAL_API_ENDPOINT}customer/files/employeeForeclosureReport/`,
        grossAdvanceReportFile: `${PORTAL_API_ENDPOINT}customer/files/grossAdvanceReport/`,
        manualSendBackPaysReportFile: `${PORTAL_API_ENDPOINT}customer/files/sentBackPaysReport/`,
        dashboardMetrics: `${PORTAL_API_ENDPOINT}customer/dashboard/metrics/`,
        currentUser: `${PORTAL_API_ENDPOINT}currentUser/`,
        agiAdjustment: `${PORTAL_API_ENDPOINT}customer/agiAdjustment/`,
        foraAdjustment: `${PORTAL_API_ENDPOINT}customer/foraAdjustment/`,
        customerRoles: `${PORTAL_API_ENDPOINT}customer/roles/`,
        companyGroupRoles: `${PORTAL_API_ENDPOINT}companygroup/roles/`,
    },
    fortnoxIntegrationBaseUrl: FORTNOX_INTEGRATION_API_ENDPOINT,
    plandayIntegrationBaseUrl: PLANDAY_INTEGRATION_API_ENDPOINT,
    tengellaIntegrationBaseUrl: TENGELLA_INTEGRATION_API_ENDPOINT,
    blazorAppVersion: BLAZOR_APP_VERSION,
    isInternalUrl: (url: string) => {
        return url.startsWith(apiConfig.baseUrl) ||
        url.startsWith(apiConfig.fortnoxIntegrationBaseUrl) ||
        url.startsWith(apiConfig.plandayIntegrationBaseUrl) ||
        url.startsWith(apiConfig.tengellaIntegrationBaseUrl)
    }
}
